import { PropTypes } from 'prop-types'
import T from 'i18n-react';
import WorkflowSection from '../../../../Section/WorkflowSection'
import '../../../../Section/section.css'
import WorkflowButton from '../../../../Section/WorkflowButton'
import { WorkflowButtonStates } from '../../../../Section/WorkflowButtonStates'
import EditIcon from '@mui/icons-material/Edit'

const ConfirmAuthorize = ({ confirmAuthorizeState, onWorkflowButtonAction, onFadeOut, ticketType }) => {
    var { primaryShowConfirm, spouseShowConfirm, primaryShowAuthorize, primaryAuthorizeAddedQC, spouseShowAuthorize, spouseFirstName } = confirmAuthorizeState;
    var showConfirm = primaryShowConfirm || spouseShowConfirm;
    var showAuthorize = primaryShowAuthorize || primaryAuthorizeAddedQC || spouseShowAuthorize;
   
    return showConfirm || showAuthorize ? (
        <WorkflowSection titleKey={'WorkflowPanel.securityTitleWF'} taxYear={0} currentTaxYear={0} canClose={false} ticketType={ticketType}>
            {showConfirm &&
                <WorkflowButton buttonKey="confirm" name="confirm" buttonState={WorkflowButtonStates.SHOW} icon="fa-user-secret"
                text={'WorkflowPanel.confirm.titleWF'} textProps={{ SpouseFirstName: spouseFirstName }} ticketType={ticketType}
                    onClick={() => onWorkflowButtonAction('confirm', 0)} onFadeOut={onFadeOut} />
            }
            {showAuthorize &&
                <WorkflowButton buttonKey="authorize" name="authorize" buttonState={WorkflowButtonStates.SHOW}
                text={'WorkflowPanel.authorize.titleWF'} textProps={{ SpouseFirstName: spouseFirstName }} ticketType={ticketType}
                    onClick={() => onWorkflowButtonAction('authorize', 0)} onFadeOut={onFadeOut} >
                    <EditIcon className="large_mi_icon" />
                </WorkflowButton>
            }
            <div className="wf-section-label-container">
                {T.translate('WorkflowPanel.profile.subtextWF')}
            </div>
        </WorkflowSection>
    ) : null
}

ConfirmAuthorize.propTypes = {
    confirmAuthorizeState: PropTypes.object.isRequired,
    onWorkflowButtonAction: PropTypes.func.isRequired,
    onFadeOut: PropTypes.func.isRequired,
    ticketType: PropTypes.string
}

export default ConfirmAuthorize;